<!-- 查询模板 -->
<template>
    <div class="container">
        <div v-if="dataTable.length > 0" class="template-card">
            <div class="card-preview">
                <img v-if="dataTable[0].cover_img" class="preview-img" :src="dataTable[0].cover_img" />
                <div v-else class="preview-placeholder">暂无预览图</div>
            </div>
            <div class="card-info">
                <div class="info-item">
                    <span class="label">模板名称：</span>
                    <span class="value">{{ dataTable[0].title }}</span>
                </div>
                <div class="info-item">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ dataTable[0].created_at }}</span>
                </div>
                <div>
                    <span class="label">入口链接：</span>
                        <span class="theme-color cursor-pointer" @click="goCopy">{{ config.apiUrl + "/q/" + admin_id }}</span>
                        <Icon class="cursor-pointer" type="md-copy" color="var(--primary-color)" @click="goCopy" />
                    
                </div>
                <div class="card-actions">
                    <Button
                        v-if="dataTable[0].merchant_query_template_id"
                        type="warning"
                        ghost
                        @click="linkDiy(dataTable[0])"
                    >编辑</Button>
                    <Button v-if="!dataTable[0].merchant_query_template_id" type="primary" ghost @click="goUse(dataTable[0])">
                        使用
                    </Button>
                </div>
            </div>
        </div>
        <div v-else class="empty-state">
            <Icon type="md-document" size="48" color="#ccc" />
            <p>暂无数据</p>
        </div>
        <!-- editDiy全屏弹窗 -->
        <editDiy
            v-model="editDiyModal"
            :is-modal="true"
            :diy-id="editDiyProps.diyId"
            :page-id="editDiyProps.pageId"
            @on-close="closeEditDiyModal"
        ></editDiy>
    </div>
</template>

<script>
import {getStorages } from "@/utils/helper";
import { template_query_template, template_modify_use } from "@/api/index";
import editDiy from "./editDiy.vue";
export default {
    components: {
        editDiy
    },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            admin_id : getStorages('infos').admin_id,
            dataTable: [],
            editDiyModal: false,
            editDiyProps: {
                pageId: "",
                diyId: ""
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        getList() {
            template_query_template(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.list;
                    this.total = res.data.count;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 打开editDiy弹窗
        openEditDiy(pageId) {
            this.editDiyProps = {
                pageId: pageId,
                diyId: "2"
            };
            this.editDiyModal = true;
        },
        // 关闭editDiy弹窗
        closeEditDiyModal() {
            this.editDiyModal = false;
            this.getList();
        },
        // 使用
        goUse(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确定要使用此模板（" + row.title + "）？",
                onOk: () => {
                    template_modify_use({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                            this.openEditDiy(row.id);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 跳转DIY
        linkDiy(row) {
            this.openEditDiy(row.id);
        },
        goCopy() {
            let text = this.config.apiUrl + "/query?id=" + this.admin_id;
            this.$copyText(text).then(
                (e) => {
                    this.$Message.success({ background: true, content: "复制成功", closable: true });
                },
                (err) => {
                    alert("复制失败");
                    console.log(err);
                }
            );
        }
    },
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.template-card {
    display: flex;
    gap: 24px;
    padding: 24px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    max-width: 600px;
}
.card-preview {
    width: 120px;
    height: 180px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}
.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.preview-placeholder {
    color: #94a3b8;
    font-size: 12px;
}
.card-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
}
.info-item {
    display: flex;
    align-items: center;
}
.label {
    color: #64748b;
    font-size: 14px;
}
.value {
    color: #0f172a;
    font-size: 14px;
    font-weight: 500;
}
.card-actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: #94a3b8;
}
.empty-state p {
    margin-top: 12px;
}
</style>